import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import { useTranslation } from 'react-i18next';
import Seo from '../components/Seo.js';

const SignUp = () => {
  const { t } = useTranslation();
  return (
    <main className="container mx-auto px-4 py-8">
      <Seo path="/signup" title={t('signup.seo.title')} description={t('signup.seo.description')} />
      <h1 className="text-3xl font-bold mb-4">{t('signup.title')}</h1>
      <Authenticator initialState="signUp" />
    </main>
  );
};

export default SignUp;
